(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ctw-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var GA_ID = 'G-7MYH1ED2J4';
    var META_PIXEL_ID = '1902971686491415';
    var CTW_TRACK_URL = 'https://darlin-member.darlinofficial.workers.dev/api/ctw-track';

    function campaignSource() {
      var params = new URLSearchParams(window.location.search);
      var explicit = params.get('utm_source') || params.get('src');
      if (explicit) return explicit.slice(0, 80);
      if (/\bLine\//i.test(navigator.userAgent || '')) return 'line-in-app';
      if (document.referrer) {
        try { return new URL(document.referrer).hostname.replace(/^www\./, '').slice(0, 80); } catch (e) {}
      }
      return 'direct';
    }

    function visitorId() {
      var key = 'darlin_ctw_vid';
      try {
        var current = window.localStorage.getItem(key);
        if (current) return current;
        current = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
        window.localStorage.setItem(key, current);
        return current;
      } catch (e) { return ''; }
    }

    function trackFirstParty(name, payload) {
      var body = JSON.stringify({
        event: name,
        source: payload.source,
        visitor_id: visitorId(),
        page_path: window.location.pathname,
        detail: payload.cta_position || payload.state || payload.color || ''
      });
      try {
        if (navigator.sendBeacon) {
          navigator.sendBeacon(CTW_TRACK_URL, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
        } else {
          fetch(CTW_TRACK_URL, { method: 'POST', headers: { 'content-type': 'text/plain;charset=UTF-8' }, body: body, keepalive: true, mode: 'cors' }).catch(function () {});
        }
      } catch (e) {}
    }

    function track(name, parameters) {
      var payload = Object.assign({ campaign: 'ctw_lazy_walk_2026', source: campaignSource() }, parameters || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));

      if (typeof window.gtag === 'function') {
        window.gtag('event', name, Object.assign({ send_to: GA_ID }, payload));
      }
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', name, Object.assign({ pixel_id: META_PIXEL_ID }, payload));
      }
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
      trackFirstParty(name, payload);
    }

    function initializeCountdown(root) {
      var countdown = root.querySelector('[data-ctw-countdown]');
      if (!countdown) return;

      function update() {
        countdown.querySelectorAll('[data-countdown-target]').forEach(function (item) {
          var output = item.querySelector('[data-countdown-value]');
          var remaining = new Date(item.dataset.countdownTarget).getTime() - Date.now();
          if (remaining <= 0) {
            output.textContent = countdown.dataset.live;
            return;
          }
          var totalMinutes = Math.floor(remaining / 60000);
          var days = Math.floor(totalMinutes / 1440);
          var hours = Math.floor((totalMinutes % 1440) / 60);
          var minutes = totalMinutes % 60;
          output.textContent = days + ' ' + countdown.dataset.days + ' · ' + hours + ' ' + countdown.dataset.hours + ' · ' + minutes + ' ' + countdown.dataset.minutes;
        });
      }

      update();
      window.setInterval(update, 60000);
    }

    function initializeVideo(root) {
      var video = root.querySelector('.ctw-landing__video');
      var toggle = root.querySelector('[data-ctw-video-toggle]');
      if (!video || !toggle) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) video.pause();

      function render() {
        var paused = video.paused;
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? 'เล่นวิดีโอ' : 'หยุดวิดีโอชั่วคราว');
        toggle.querySelector('[data-ctw-video-icon]').textContent = paused ? '▶' : 'Ⅱ';
      }

      toggle.addEventListener('click', function () {
        if (video.paused) video.play().catch(function () {});
        else video.pause();
        render();
        track('ctw_video_toggle', { state: video.paused ? 'paused' : 'playing' });
      });
      video.addEventListener('play', render);
      video.addEventListener('pause', render);
      render();
    }

    function initializeCarousel(root) {
      var viewport = root.querySelector('.ctw-landing__carousel-viewport');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.ctw-landing__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ctw-carousel-dot]'));
      var status = root.querySelector('[data-ctw-carousel-status]');
      if (!viewport || !slides.length || !dots.length) return;

      function activate(index, shouldTrack) {
        dots.forEach(function (dot, dotIndex) {
          if (dotIndex === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (status) status.textContent = slides[index].dataset.slideCaption || '';
        if (shouldTrack) track('ctw_carousel_select', { slide_index: index + 1, color: slides[index].dataset.slideCaption || '' });
      }

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          slides[index].scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
          activate(index, true);
        });
      });

      var ticking = false;
      viewport.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var index = Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
          activate(Math.max(0, Math.min(index, slides.length - 1)), false);
          ticking = false;
        });
      }, { passive: true });
      activate(0, false);
    }

    function initialize(root) {
      if (!root || root.dataset.ctwInitialized === 'true') return;
      root.dataset.ctwInitialized = 'true';
      root.querySelectorAll('[data-ctw-cta]').forEach(function (button) {
        try {
          var destination = new URL(button.href);
          destination.searchParams.set('src', campaignSource());
          destination.searchParams.set('vid', visitorId());
          destination.searchParams.set('auto', '1');
          destination.searchParams.set('cta', button.dataset.ctwCta || 'unknown');
          button.href = destination.toString();
        } catch (e) {}
        button.addEventListener('click', function () {
          track('ctw_waitlist_cta_click', { cta_position: button.dataset.ctwCta || 'unknown' });
        });
      });
      initializeCountdown(root);
      initializeVideo(root);
      initializeCarousel(root);
      track('ctw_landing_view', { page_path: window.location.pathname });
    }

    function initializeAll(scope) {
      if (scope.matches && scope.matches('[data-ctw-root]')) initialize(scope);
      scope.querySelectorAll('[data-ctw-root]').forEach(initialize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
